export const ANALYTICS_PREFIX = 'Webpage';

const ACTIVATION_BASE = `${ANALYTICS_PREFIX}.Activation`;
const ACTIVATION_EVENTS = {
    promotionTabClicked: `${ACTIVATION_BASE}.PromotionTabClicked`,
    androidStoreLinkClicked: `${ACTIVATION_BASE}.AndroidStoreLinkClicked`,
    IOSStoreLinkClicked: `${ACTIVATION_BASE}.IOSStoreLinkClicked`
};

const MEMBERSHIP_BASE = `${ANALYTICS_PREFIX}.Membership`;
const MEMBERSHIP_EVENTS = {
    pageOpened: `${MEMBERSHIP_BASE}.PageOpened`,
    activationSubmitted: `${MEMBERSHIP_BASE}.ActivationSubmitted`
};

const EAP_PORTAL_BASE = `${ANALYTICS_PREFIX}.EAPPortal`;
const EAP_PORTAL_EVENTS = {
    pageOpened: `${EAP_PORTAL_BASE}.PageOpened`,
    formSubmitted: `${EAP_PORTAL_BASE}.FormSubmitted`
};

const SFTP_BASE = `${ANALYTICS_PREFIX}.SFTP`;
const SFTP_EVENTS = {
    passwordGenerationOpened: `${SFTP_BASE}.PasswordGenerationOpened`,
    generatePasswordClicked: `${SFTP_BASE}.GeneratePasswordClicked`
};

export const ANALYTICS_EVENTS = {
    activation: ACTIVATION_EVENTS,
    membership: MEMBERSHIP_EVENTS,
    eapPortal: EAP_PORTAL_EVENTS,
    sftp: SFTP_EVENTS
};
